var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconTaskActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.71,9.29c-0.39-0.39-1.02-0.39-1.41,0L14,10.59l-0.29-0.29c-0.39-0.39-1.02-0.39-1.41,0s-0.39,1.02,0,1.41l1,1 C13.49,12.9,13.74,13,14,13s0.51-0.1,0.71-0.29l2-2C17.1,10.32,17.1,9.68,16.71,9.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,5c0-0.55-0.45-1-1-1H5C4.45,4,4,4.45,4,5v16c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V5c0-0.55-0.45-1-1-1h-1 c-0.55,0-1,0.45-1,1s0.45,1,1,1v14H6V6C6.55,6,7,5.55,7,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,2H9C8.45,2,8,2.45,8,3v4c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1V3C16,2.45,15.55,2,15,2z M14,6h-4V4h4V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,12c0,0.55,0.45,1,1,1s1-0.45,1-1v-2c0-0.55-0.45-1-1-1s-1,0.45-1,1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,17c0,0.55,0.45,1,1,1s1-0.45,1-1v-2c0-0.55-0.45-1-1-1s-1,0.45-1,1V17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71,14.29c-0.39-0.39-1.02-0.39-1.41,0L14,14.59l-0.29-0.29c-0.39-0.39-1.02-0.39-1.41,0s-0.39,1.02,0,1.41L12.59,16 l-0.29,0.29c-0.39,0.39-0.39,1.02,0,1.41C12.49,17.9,12.74,18,13,18s0.51-0.1,0.71-0.29L14,17.41l0.29,0.29 C14.49,17.9,14.74,18,15,18s0.51-0.1,0.71-0.29c0.39-0.39,0.39-1.02,0-1.41L15.41,16l0.29-0.29C16.1,15.32,16.1,14.68,15.71,14.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTaskActive);
export default __webpack_public_path__ + "static/media/menu_icon_task_active.adb45fafcb64d5371a7df6ed5bfaec50.svg";
export { ForwardRef as ReactComponent };